import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { TruncatePipe } from 'src/app/shared/pipes/truncate.pipe';
import { ContentListResponseDto } from 'src/app/shared/dtos/content-list.dto';
import { RecentlyViewedComponent } from 'src/app/core/components/recently-viewed/recently-viewed.component';
import { LocalStorageService } from 'src/app/shared/services/local-storage.service';
import { combineLatest, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AsyncPipe } from '@angular/common';
import { FeedItemDto, FeedItemsResponseDto } from 'src/app/shared/dtos/feed-items.dto';
import { SliderComponent } from 'src/app/shared/components/slider/slider.component';
import { DialogService } from 'primeng/dynamicdialog';
import { AnalyticsService } from 'src/app/core/services/analytics.service';
import { AnalyticsEventName } from 'src/app/core/enums/analytics.enum';
import { TemplateTypeDirective } from 'src/app/shared/directives/template-type.directive';
import { TranslocoPipe } from '@jsverse/transloco';
import { WhatsNewModal } from 'src/app/core/components/modals/whats-new-modal/whats-new-modal';

@Component({
  selector: 'app-dashboard-home',
  imports: [
    TruncatePipe,
    RouterLink,
    RecentlyViewedComponent,
    AsyncPipe,
    SliderComponent,
    TranslocoPipe,
    TemplateTypeDirective,
  ],
  templateUrl: './dashboard-home.component.html',
  styleUrl: './dashboard-home.component.scss'
})
export class DashboardHomeComponent implements OnInit {
  private readonly activatedRoute = inject(ActivatedRoute);
  private readonly localStorageService = inject(LocalStorageService);
  private readonly dialogService = inject(DialogService);
  private readonly analyticsService = inject(AnalyticsService);
  
  protected readonly itemTemplateType: { $implicit: FeedItemDto };

  protected readonly hasRecentlyViewedItems = this.localStorageService.hasKey('recentlyViewedItems');

  private readonly contentList$: Observable<ContentListResponseDto> = this.activatedRoute.parent!.data.pipe(
    map(data => data['contentList']),
  );

  private readonly feedItems$: Observable<FeedItemsResponseDto> = this.activatedRoute!.data.pipe(
    map(data => {
      this.allFeedItems = data['feedItems'];
      return data['feedItems'];
    }),
  );

  private allFeedItems: FeedItemsResponseDto;

protected readonly data$: Observable<{ contentList: ContentListResponseDto; feedItems: FeedItemsResponseDto }> = combineLatest([
  this.contentList$,
  this.feedItems$
]).pipe(
  map(([contentList, feedItems]) => {
    return {
      contentList: {
        ...contentList,
        content: [...contentList.content].sort((rangeA, rangeB) => rangeA.name.localeCompare(rangeB.name))
      },
      feedItems
    };
  })
);

  ngOnInit(): void {
    this.analyticsService.analyticsPageData = {
      itemName: 'home',
      itemId: 'home'
    };

    this.analyticsService.trackPageLoad();
  }

  protected openWhatsNewDialog(feedItemTitle: string): void {
    this.dialogService.open(WhatsNewModal, {
      header: feedItemTitle,
      focusOnShow: false,
      closable: true,
      modal: true,
      dismissableMask: true,
      width: '860px',
      breakpoints: {
        '1400px': '860px',
        '960px': '75%',
        '640px': '90%'
      },
      inputValues: {
        allFeedItems: this.allFeedItems,
        currentFeedTitle: feedItemTitle,
      }
    });

    this.analyticsService.trackEvent(AnalyticsEventName.ItemClick, {
      itemId: feedItemTitle,
      itemName: feedItemTitle,
    })
  }
}
